import { z } from 'zod';

/** A sign-in of the account (Settings › Account › Signed-in devices). */
export const accountDeviceSchema = z.object({
  id: z.string(),
  kind: z.enum(['browser', 'desktop', 'phone', 'computer']),
  /** `Safari on iPhone`, `Crowdex for macOS`, a linked computer's name. */
  label: z.string(),
  current: z.boolean(),
  createdAt: z.string(),
  lastActiveAt: z.string(),
});

/** `GET /api/account/devices`: the account's sign-ins, and the computers linked to it. */
export const accountDevicesSchema = z.object({
  devices: z.array(accountDeviceSchema),
  /** Computers whose Crowdex is linked to this account (Crowdex Cloud); this one first. */
  computers: z.array(
    z.object({
      id: z.string().nullable(),
      name: z.string(),
      platform: z.string().nullable(),
      /** The computer this page runs on. */
      current: z.boolean(),
      linkedAt: z.string().nullable(),
    }),
  ),
});

/** What a linked computer tells the cloud of itself when it links (`POST /api/cloud-link/token`). */
export const cloudLinkMachineSchema = z.object({
  name: z.string().trim().min(1).max(120),
  platform: z.string().trim().min(1).max(40),
});

export type AccountDevice = z.infer<typeof accountDeviceSchema>;
export type AccountDevices = z.infer<typeof accountDevicesSchema>;
export type CloudLinkMachine = z.infer<typeof cloudLinkMachineSchema>;
